import { toast } from "@/hooks/use-toast";
import { createClient } from "@/utils/supabase/client";

const supabase = createClient();

const useUtilStore = (set, get) => ({
  showToast: ({ title, description, variant = "default" }) => {
    toast({
      title,
      description,
      variant,
    });
  },

  // Fetch random tags
  fetchRandomTags: async (limit = 15, retryCount = 0) => {
    try {
      const { data, error } = await supabase
        .from("tags")
        .select("id, name, category, show_onboarding")
        .eq("show_onboarding", true)
        .limit(limit)
        .order("created_at", { ascending: false })
        .then((result) => {
          if (result.data) {
            return {
              ...result,
              data: result.data.sort(() => Math.random() - 0.5),
            };
          }
          return result;
        });

      if (error) throw error;

      // If we got empty data but no error, that's unusual - retry once
      if (!data || data.length === 0) {
        console.warn("No tags returned from the database");

        // If this is our first try, retry once
        if (retryCount < 2) {
          console.log(`Retrying fetchRandomTags, attempt ${retryCount + 1}`);
          return await get().fetchRandomTags(limit, retryCount + 1);
        }

        // If we've retried, return fallback tags
        return {
          success: true,
          tags: [
            {
              id: "fallback-1",
              name: "Technology",
              category: "topic",
              show_onboarding: true,
            },
            {
              id: "fallback-2",
              name: "Art",
              category: "topic",
              show_onboarding: true,
            },
            {
              id: "fallback-3",
              name: "Business",
              category: "topic",
              show_onboarding: true,
            },
            {
              id: "fallback-4",
              name: "Education",
              category: "topic",
              show_onboarding: true,
            },
            {
              id: "fallback-5",
              name: "Health",
              category: "topic",
              show_onboarding: true,
            },
          ],
        };
      }

      return {
        success: true,
        tags: data,
      };
    } catch (error) {
      console.error("Error fetching tags:", error);

      // Retry logic for network errors
      if (retryCount < 2) {
        console.log(
          `Network error, retrying fetchRandomTags, attempt ${retryCount + 1}`
        );
        return new Promise((resolve) => {
          setTimeout(() => {
            resolve(get().fetchRandomTags(limit, retryCount + 1));
          }, 1000); // Wait 1 second before retrying
        });
      }

      toast({
        title: "Error",
        description: "Failed to load tags",
        variant: "destructive",
      });

      // Return fallback tags after all retries fail
      return {
        success: true,
        tags: [
          {
            id: "fallback-1",
            name: "Technology",
            category: "topic",
            show_onboarding: true,
          },
          {
            id: "fallback-2",
            name: "Art",
            category: "topic",
            show_onboarding: true,
          },
          {
            id: "fallback-3",
            name: "Business",
            category: "topic",
            show_onboarding: true,
          },
          {
            id: "fallback-4",
            name: "Education",
            category: "topic",
            show_onboarding: true,
          },
          {
            id: "fallback-5",
            name: "Health",
            category: "topic",
            show_onboarding: true,
          },
        ],
      };
    }
  },
});

export default useUtilStore;
